<div class="qira-dialog">

  <div class="qira-dialog__header">
    <div class="qira-dialog__title-row">
      <mat-icon class="qira-dialog__icon">currency_exchange</mat-icon>
      <h2 class="qira-dialog__title">Confirm Return</h2>
    </div>
  </div>

  <div class="qira-dialog__content">
    <p class="qira-dialog__lead">You are confirming that the resident has ended the lease in good standing.</p>
    <ul class="qira-dialog__list">
      <li>If a traditional security deposit was paid, Qira will return the funds to the resident.</li>
      <li>If a Qira deposit alternative was used, the funds will be returned to Qira and the checkout will be closed.</li>
    </ul>
  </div>

  <div class="qira-dialog__actions">
    <button mat-stroked-button class="qira-dialog__cancel" (click)="onCancel()">{{ closeButtonText }}</button>
    <button mat-flat-button color="primary" class="qira-dialog__confirm" (click)="onAction()">{{ model.okButtonText }}</button>
  </div>

</div>
